// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falColumns3: CreateIconOptions = {
  "displayName": "FALColumns3",
  "viewBox": "0, 0, 640, 512",
  "d": "M448 64l0 384 128 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L448 64zm-32 0L224 64l0 384 192 0 0-384zM192 448l0-384L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l128 0zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z"
};
